import ViewFactory from '@/Factories/ViewFactory';
import ComponentManager from '@/Management/ComponentManager';
import TokenValidationViewModel from '@/Components/TwoFaktorAuth/LoginFlow/TokenValidation/TokenValidationViewModel';
import TokenValidationView from '@/Components/TwoFaktorAuth/LoginFlow/TokenValidation/TokenValidationView';
import {IViewFactoryConstructorParameter} from '#/CoreFrameInterfaces';
import {ITokenValidationViewModelConstructorParameter} from '#/DefaultViewExtensionInterfaces';

interface ITokenValidationViewFactoryConstructorParameters extends IViewFactoryConstructorParameter {
    viewModelParameters: ITokenValidationViewModelConstructorParameter;
}

export default class TokenValidationViewFactory extends ViewFactory {
    
    private TokenValidationViewModel = ComponentManager.getViewModel<typeof TokenValidationViewModel>('TokenValidation');
    private TokenValidationView = ComponentManager.getView<typeof TokenValidationView>('TokenValidationView');

    public viewModel: TokenValidationViewModel;
    
    public constructor(private params: ITokenValidationViewFactoryConstructorParameters) {
        super(params);
    }

    public getView(): JQuery<HTMLElement> {
        if (this.viewModel == null) {
            this.viewModel = this.createViewModel();
        }

        if (this.view == null) {
            this.view = this.createView(this.viewModel);
        }

        const tuple = this.view.getTuple();
        return tuple.view;
    }

    protected createViewModel(): TokenValidationViewModel {
        return new this.TokenValidationViewModel({ ...this.params.viewModelParameters, locator: '2fa' });
    }

    protected createView(viewModel: TokenValidationViewModel): TokenValidationView {
        return new this.TokenValidationView(viewModel, this.createRootElement('TokenValidation'));
    }
}

ComponentManager.setFactory('TokenValidationView', TokenValidationViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');